import React from "react";
// import { Api, Utils } from '@jesseteal/teal-react'

const IsoImage = () => {
  return (
    <div className="tc">
      <img
        src="/QualitySysCert_ISO9001_col.png"
        alt="iso stamp"
        style={{ width: 200, height: 240 }}
      />
    </div>
  );
};

export default IsoImage;
